import { render, staticRenderFns } from "./withdraw_record.vue?vue&type=template&id=54d4b604&scoped=true&"
import script from "./withdraw_record.vue?vue&type=script&lang=js&"
export * from "./withdraw_record.vue?vue&type=script&lang=js&"
import style0 from "./withdraw_record.vue?vue&type=style&index=0&id=54d4b604&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4b604",
  null
  
)

export default component.exports